import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-page-down-custom",
  "use": "icon-page-down-custom-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 17 16\" id=\"icon-page-down-custom\"><path fill=\"#fff\" d=\"M.5 16V0h16v16z\" opacity=\".01\" /><path fill-rule=\"evenodd\" d=\"m8.5 8.653 4.242-4.243-.653-.653-3.59 3.59-3.59-3.59-.652.653zm0 4 4.242-4.243-.653-.653-3.59 3.59-3.59-3.59-.652.653z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol